/**
 * ID generation utilities for session and turn identifiers.
 */

import { ulid } from 'ulid';

/**
 * Generates a new ULID for session or turn IDs.
 * ULIDs are lexicographically sortable by creation time, which makes
 * them suitable for DynamoDB SK prefixes and URL path segments.
 */
export function newSessionId(): string {
  return ulid();
}

/**
 * Validates whether a string is a valid ULID.
 * Uses the same regex as the backend get-session-turns.ts for consistency (T-02-51).
 * Valid ULID: 26 chars, Crockford base32 alphabet [0-9A-HJKMNP-TV-Z].
 */
export function isValidUlid(s: string): boolean {
  return /^[0-9A-HJKMNP-TV-Z]{26}$/.test(s);
}
